export const bartOrangeLakeBay = [
    [37.79720479635294, -122.26530906502254], // BART Lake Merritt
    [37.792252900318374, -122.25776507295016],
    [37.79171995309572, -122.25695216594366],
    [37.79088330155615, -122.25517512697007],
    [37.79034529234419, -122.25312163622704],
    [37.789877865417424, -122.25181840630839],
    [37.78584582185619, -122.24284893414057],
    [37.78521874536135, -122.24147443324499],
    [37.781906709500355, -122.23563200035736],
    [37.78123565234137, -122.23471023371665],
    [37.7795144586224, -122.23256240267287],
    [37.77887184745448, -122.2316109999829],
    [37.774846543093545, -122.22408624109603], // BART Fruitvale
    [37.773095339730624, -122.22104709573894],
    [37.77166606508127, -122.21800247092833],
    [37.77163769605489, -122.2178990212239],
    [37.77062994270543, -122.21635083360262],
    [37.770251655177205, -122.21589829991487],
    [37.76964175096592, -122.21522531209013],
    [37.76649083101313, -122.21201615393973],
    [37.75535317622429, -122.19887678562145],
    [37.75368286189276, -122.19671804485594], // BART Coliseum
    [37.735465765347506, -122.17497917580079],
    [37.72637966655833, -122.16422739613965],
    [37.726001858052875, -122.16383162151757],
    [37.72498306550186, -122.16303187764058],
    [37.72181643448426, -122.16067398217488], // BART San Leandro
    [37.7194581354798, -122.15913808265516],
    [37.71889366132991, -122.15847803579956],
    [37.71872788274238, -122.15830409120578],
    [37.712435601951626, -122.14913975419066],
    [37.69694130723014, -122.12669601081214], // BART Bay Fair
    [37.68971793886349, -122.1156636839473],
];